module.exports = new __parcel__URL__("buckley-listening.840b522b.png").toString();